// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__I6CKu","requiredAsterisk":"Info_requiredAsterisk__2cpY-"};